import {StepIconProps} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {CustomStepperStyled} from './styles';

const CustomStepper = (stepperProps: StepIconProps) => {
	const {active, completed, className} = stepperProps;

	return (
		<CustomStepperStyled ownerState={{active}} className={className}>
			{completed ? (
				<Icon name="check-default" className="CustomStepperIcon-completedIcon" />
			) : (
				<div className="CustomStepperIcon-circle" />
			)}
		</CustomStepperStyled>
	);
};

export {CustomStepper};
